import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import category from './modules/category'
import company from './modules/company'
import event from './modules/event'
import eventType from './modules/eventType'
import integration from './modules/integration'
import post from './modules/post'
import snackbar from './modules/snackbar'
import ui from './modules/ui'
import user from './modules/user'
import workTime from './modules/workTime'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    category,
    company,
    event,
    eventType,
    integration,
    post,
    snackbar,
    ui,
    user,
    workTime,
  },
})

if (process.env.NODE_ENV === 'development') {
  store.devSyncAuth = () => {
    Vue.nextTick(() => {
      store.state.auth.token = localStorage.getItem('_token') || null
      store.state.auth.refreshToken = localStorage.getItem('_refreshToken') || null
      store.dispatch('auth/refresh').catch(console.error)
    })
  }
}
export default store
